import { render, staticRenderFns } from "./customerVipBenefit.vue?vue&type=template&id=4281d0e3&scoped=true&"
import script from "./customerVipBenefit.vue?vue&type=script&lang=js&"
export * from "./customerVipBenefit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4281d0e3",
  null
  
)

export default component.exports